export const SITE = {
    brand: "Vyom",
    tagline: "Linen, refined.",
    parent: "From the house of United Bleachers",
    legacy: "Seventy-five years of textile craft",
    nav: [
        { label: "Home", href: "/" },
        { label: "About", href: "/about" },
        { label: "Collections", href: "/collections" },
        { label: "Capabilities", href: "/capabilities" },
        { label: "Contact", href: "/contact" },
    ],
    markets: ["Europe", "Japan", "Australia"],
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1644316551857-8096d9b2304c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxmb2xkZWQlMjBsaW5lbiUyMGZhYnJpYyUyMG5ldXRyYWwlMjB0ZXh0dXJlJTIwY2xvc2V1cHxlbnwwfHx8fDE3Nzc5OTUwNDd8MA&ixlib=rb-4.1.0&q=85",
    hero_alt:
        "https://images.pexels.com/photos/28536695/pexels-photo-28536695.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1600",
    heritage:
        "https://images.pexels.com/photos/30618181/pexels-photo-30618181/free-photo-of-cozy-natural-linen-bedding-texture-close-up.jpeg?auto=compress&cs=tinysrgb&w=1600",
    bath: "https://static.prod-images.emergentagent.com/jobs/564b9ba8-563e-4d9e-aac9-021ba4f3c993/images/54ffce5e26f969a1402136bb3b3f492c266626ebb79aebb143a43bdd611c4c6a.png",
    bedding:
        "https://images.pexels.com/photos/4153160/pexels-photo-4153160.jpeg?auto=compress&cs=tinysrgb&w=1400",
    fabric: "https://images.pexels.com/photos/6568638/pexels-photo-6568638.jpeg?auto=compress&cs=tinysrgb&w=1400",
    duvet: "https://images.pexels.com/photos/27671434/pexels-photo-27671434/free-photo-of-morning.jpeg?auto=compress&cs=tinysrgb&w=1400",
    pillow: "https://images.pexels.com/photos/28513850/pexels-photo-28513850/free-photo-of-relaxing-white-linen-sheets-in-soft-light.jpeg?auto=compress&cs=tinysrgb&w=1400",
    table: "https://images.pexels.com/photos/7445132/pexels-photo-7445132.jpeg?auto=compress&cs=tinysrgb&w=1400",
    quilt: "https://images.pexels.com/photos/11335321/pexels-photo-11335321.jpeg?auto=compress&cs=tinysrgb&w=1400",
    studio: "https://images.pexels.com/photos/7445127/pexels-photo-7445127.jpeg?auto=compress&cs=tinysrgb&w=1600",
    weave: "https://images.pexels.com/photos/10096010/pexels-photo-10096010.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const COLLECTIONS = [
    {
        slug: "bedsheets",
        title: "Bedsheets & Blankets",
        copy: "Long-staple cotton woven for everyday repose.",
        image: IMAGES.bedding,
    },
    {
        slug: "duvet-covers",
        title: "Duvet Covers",
        copy: "Soft architecture for the bed — drape, weight, calm.",
        image: IMAGES.duvet,
    },
    {
        slug: "pillow-covers",
        title: "Pillow Covers",
        copy: "A quiet finish, considered down to the seam.",
        image: IMAGES.pillow,
    },
    {
        slug: "table-linen",
        title: "Table Linen",
        copy: "Hand-finished cloth for the slow ritual of dining.",
        image: IMAGES.table,
    },
    {
        slug: "quilts",
        title: "Quilts",
        copy: "Layered warmth, kept honest by the loom.",
        image: IMAGES.quilt,
    },
    {
        slug: "bath-linen",
        title: "Bath Linen",
        copy: "Towels with a memory — absorbent, enduring, true.",
        image: IMAGES.bath,
    },
];

export const CAPABILITIES = [
    {
        index: "01",
        title: "Founder-led attention",
        copy: "Direct, accountable leadership at every stage of the order.",
    },
    {
        index: "02",
        title: "Tailored orders",
        copy: "Small batches and large runs, calibrated to your house.",
    },
    {
        index: "03",
        title: "Export-trusted",
        copy: "Long-standing partners with distinguished houses across the world.",
    },
    {
        index: "04",
        title: "Quiet luxury, built to last",
        copy: "Linen made for daily use — refined, durable, undecorated.",
    },
    {
        index: "05",
        title: "Perfected process",
        copy: "Transparent production with no guesswork between sample and ship.",
    },
    {
        index: "06",
        title: "White-label ready",
        copy: "Custom branding for D2C, retail, and hospitality.",
    },
];
